define('lq/actionLoader',[
    'lq',
    'jquery',
    'underscore'
], function (lq, $, _) {
    
    var ActionLoader = function (url) {
        this.url = url;
        this.requestId = 0;
        this.listeners = [];
    };

    ActionLoader.prototype.addListener = function (callback) {
        this.listeners.push(callback);
    };

    ActionLoader.prototype.removeListener = function (callback) {
        var index = this.listeners.indexOf(callback);
        if (index >= 0)
            this.listeners.splice(index, 1);
    };

    ActionLoader.prototype.load = function (actionId, globals, locals, state) {
        this.requestId += 1;

        $.post({
                url: this.url.prepare(lq.getTenantUrl('LicquidAction/Navigate')),
                cache: false,
                data: {
                    id: actionId
                }
            })
            .then(this.receivedData.bind(this, actionId, globals, locals, state, this.requestId));
    };

    ActionLoader.prototype.receivedData = function (actionId, globals, locals, state, requestId, data) {
        if (requestId !== this.requestId) return;

        if (data.requiresLogin) {
            // force a redirect to make sure we don't keep any in-memory state of a previous user

            var pageUrl = 'LicquidAction/Get/' + actionId;

            var parameters = {
                globals: JSON.stringify(globals),
                parameters: JSON.stringify(locals)
            };

            var currentUrl = this.url.prepare(lq.getTenantUrl(pageUrl), parameters);
            this.url.openUrl(currentUrl);
        } else {
            _.forEach(this.listeners, function (listener) {
                listener(
                    data,
                    {
                        globals: globals,
                        locals: locals,
                        system: data.systemParameters
                    },
                    state);
            });
        }
    };

    return ActionLoader;

});
